import { COLORS } from '../../constants/colors'

export const MODAL_PAPER_STYLES = {
  backgroundColor: COLORS.background,
  border: `2px solid ${COLORS.primary}`,
  boxShadow: `0 0 20px ${COLORS.primaryShadow}`,
  minWidth: '400px',
}

export const MODAL_TITLE_STYLES = {
  color: COLORS.primary,
  textShadow: `0 0 10px ${COLORS.primaryShadow}`,
  fontWeight: 700,
}

export const MODAL_CONTENT_STYLES = {
  color: COLORS.text,
  mt: 1,
}

export const MODAL_BUTTON_STYLES = {
  fontWeight: 700,
  textTransform: 'uppercase' as const,
}
